//接口配置
// export const imgAddress = 'http://img.test.jioao.cn/'; //图片地址
export const imgAddress = ''; //图片地址
export const encryInfo = 'jioao'; //加密信息


export const upload = '/jg_selectmall/appCenter/uploadImage';//图片上传
export const login = '/jg_selectmall/appAccount/login'; //登录
export const layout = '/jg_selectmall/appAccount/logOut'; //登出


export const addNewShelves = '/jg_selectmall/goodsAppRecord/addGoodsAppRecord'//加入报价表
export const addGoodsAppReport = '/jg_selectmall/goodsAppReport/addGoodsAppReport'//加入报价篮子
export const deleteGoodsReport = '/jg_selectmall/goodsAppReport/deleteGoodsReport'//报价删除
export const exportAppGoodsReport = '/jg_selectmall/goodsAppReport/exportAppGoodsReport'//报表导出
export const selectGoodsAppReportList = '/jg_selectmall/goodsAppReport/selectGoodsAppReportList'//报价篮子商品列表
export const updateIdentityOrder = '/jg_selectmall/goodsAppReport/updateIdentityOrder'//报表排序
export const updateReport = '/jg_selectmall/goodsAppReport/updateReport'//加入报价表


export const getRealmNameConfig = '/jg_selectmall/indexPage/getRealmNameConfig'//获取登录页信息


export const enterInfo = '/jg_selectmall/indexPage/selectEnterInfo'; //首页网站信息
export const listCategories = '/jg_selectmall/indexPage/queryCategories'//新版首页分类
export const listCirculationPictures = '/jg_selectmall/indexPage/queryCirculationPictures'//新版首页轮播

export const smallSerialList = '/jg_selectmall/indexPage/smallSerialList'//新版首页期列表查询
export const smallSerialGoods = '/jg_selectmall/indexPage/smallSerialGoods'//新版首页期商品查询
export const smallSerialDetail = '/jg_selectmall/indexPage/smallSerialDetail'//新版首页期期详情查询


export const selectGoodsForEs = '/jg_selectmall/goods/goodsList'//搜索商品
export const getLabelInfo = '/jg_selectmall/goods/getLabelInfo'//获取标签列表
export const getGoodsListByLabel = '/jg_selectmall/goods/goodsList'//根据标签进行搜索商品



export const getAllShelfVo = '/jg_selectmall/goodsAppRecord/queryGoodsAppRecord'; //货架列表
export const getCountShelfVo = '/jg_selectmall/goodsAppRecord/queryGoodsShelfCount'; //货架列表左边数字
export const batchAddCollect = '/jg_selectmall/goodsAppRecord/batchAddCollect'; //批量加入回收站
export const send = '/jg_selectmall/goodsAppRecord/send'; //货架推送
export const recordCollect = '/jg_selectmall/goodsAppRecord/recordCollect'; //回收站查询
export const pushNeedSend = '/jg_selectmall/goodsAppRecord/pushNeedSend'; //推送未生效的商品
export const exportShelfVoExcel = ''//货架里导出



// 采购车
export const carGetDataQuery = '/jg_selectmall/purchasingCart/queryPurchasingCart'; //采购车数据查询
export const CarOrderUpdate = '/jg_selectmall/purchasingCart/updatePurchasingCart' //购物车修改功能
export const carAdress = '/jg_selectmall/mallOrder/queryProvinceCityArea' //采购车省份地址
export const carJoinCar = '/jg_selectmall/purchasingCart/addPurchasingCart' //批量加入采购车
export const carManyImport = '/jg_selectmall/purchasingCart/importPurchasingCart' //批量导入采购车
export const carDelate = '/jg_selectmall/purchasingCart/deletePurchasingCartOption' //采购车删除
export const carGeneratOrder = '/jg_selectmall/purchasingCart/commitPurchasingCart' //提交采购车去生成订单
export const carOrderNumAdd = '/jg_selectmall/purchasingCart/updatePurchasingCartNum' //采购车数量的增加
export const CarDownloadTemplate = '/jg_selectmall/purchasingCart/downloadPurchasingCartTemplate' //购物车模板下载
export const CarOrderNumberTotal = '/jg_selectmall/purchasingCart/queryWaitPayOrderStatistics' //订单总数小结
export const carGoToPay = '/jg_selectmall/purchasingCart/queryWaitPayOrder' //待支付订单查询
export const carSettlementOrder = '/jg_selectmall/purchasingCart/payOrder' //确认订单结算
export const cancelPurchasingOrder = "jg_selectmall/purchasingCart/cancelPurchasingOrder"; //批量删除



export const order = '/jg_selectmall/mallOrder/queryOrderList'; //订单列表
export const exportFreightDataExcel = '/jg_selectmall/mallOrder/exportFreightDataExcel' //订单运费导出
export const orderDetailInfo = '/jg_selectmall/mallOrder/queryOrderDetail'; //订单详情
export const getOrderLogistics = '/jg_selectmall/mallOrder/queryOrderLogistics'; //是否多包裹

export const afterSaleList = '/jg_selectmall/mallOrder/queryAfterSalesList'; //售后订单列表
export const addOwnerAfterSn = '/jg_selectmall/mallOrder/updateOwnerAfterOrderSn'//增加自有售后单号
export const applyAfs = '/jg_selectmall/mallOrder/queryAfterSalesApplication'; //申请售后
export const afsDetail = '/jg_selectmall/mallOrder/queryAfterSalesDetail'; //售后详情
export const loadRefundVo = '/jg_selectmall/mallOrder/queryRefundVo';
export const saveAfterSales = '/jg_selectmall/mallOrder/saveAfterSalesApplication';//售后提交保存
export const exportOrderDetail = '/jg_selectmall/mallOrder/exportMallOrder' //订单导出
export const logistics = '/jg_selectmall/mallOrder/queryExpressCompany'; //物流公司
export const submitLogistics = '/jg_selectmall/mallOrder/updateSendBack'; //提交物流信息
export const logisticsInit = '/jg_selectmall/mallOrder/queryOrderLogistics'; //获取物流信息



export const getAllExportList = '/jg_selectmall/appCenter/getExportList'//下载列表

export const exportAppJournalMall = '/jg_selectmall/appCenter/exportWalletData'; //钱包excel导出
export const queryAppJournalMall = 'jg_selectmall/appCenter/queryWalletData'//个人中心充值申请流水（新）
export const insertAppChangeApply = 'jg_selectmall/appCenter/insertAppChangeApply'//个人中心充值申请（新）
export const queryChargeApplyMall = 'jg_selectmall/appCenter/queryAppChargeApplyMall'//个人中心充值申请记录查询（新）


export const centerInfo = '/jg_selectmall/appCenter/queryPersonalData'; //个人信息
export const updatePw = '/jg_selectmall/appCenter/updatePersonalPassword'; //修改密码
export const personalitySetting = '/jg_selectmall/appCenter/updatePersonalitySetting'; //个性商城设置.
export const getPersonalitySetting = "/jg_selectmall/appCenter/queryPersonalitySetting"; //个性商城回显
export const selectSpecialArea = '/jg_selectmall/appCenter/querySpecialArea'; //个性商城特别关注区域回显
export const updateData = '/jg_selectmall/appCenter/updatePersonalData'; //个人中心修改个人信息



// 商品详情页面
export const getMallProductList = "/jg_selectmall/goods/querySkuInfo"; //商品详情列表
export const goodsInfo = '/jg_selectmall/goods/getMallGoodsDetail'; //商品信息
export const DetailLookPicture = '/jg_selectmall/goods/queryGoodsImageInfo' //商品一键下载查询图片
export const ExportGoodsDetail = '/jg_selectmall/goods/exportGoodsSpecInfo' //商品一键下载导出商品详情


export const functionDocument = '/jg_selectmall/appCenter/queryFunctionDoc'; // 功能文档



// WEBPACK FOOTER //
// ./src/config/interface.js